import { NEXEN_BUCKET_V2 } from '../config/urls';
import LibraryItem from '../shared/interfaces/libraryItem.interface';

export default function getItemFileUrl(item: LibraryItem): string {
    return `${NEXEN_BUCKET_V2}/${item.file.awsFilePath}/${item.file.awsFileName}`;
}
